import { useRef } from 'react';
import {
  Chevron,
  Menu,
  MenuItem,
  StyledTrigger,
  Wrapper
} from './SubcategoryDropdown.styled';
import { WP_REST_API_Categories } from 'wp-types';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { useRouter } from 'next/router';

interface SimpleDropdownProps {
  items: WP_REST_API_Categories;
  locale?: string;
  isActive?: boolean;
  isOpen: boolean;
}

export default function SubcategoryDropdown({
  locale,
  items,
  isActive = false,
  isOpen
}: SimpleDropdownProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const getHref = (slug: string) => {
    return `${getAppUrl(APP_URLS.blog, locale)}/category/${slug}`;
  };
  const handleSelect = (slug: string) => {
    router.push(getHref(slug));
  };
  const handleKeyPress = (
    e: React.KeyboardEvent<HTMLAnchorElement>,
    slug: string
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSelect(slug);
    }
  };

  return (
    <Wrapper ref={wrapperRef}>
      <StyledTrigger aria-haspopup="listbox" aria-expanded={isOpen}>
        <Chevron $isOpen={isOpen} $isActive={isActive} />
      </StyledTrigger>

      {isOpen && (
        <Menu role="listbox">
          {items.map((cat) => (
            <MenuItem
              key={cat.id}
              role="option"
              as="a"
              href={getHref(cat.slug)}
              onClick={() => handleSelect(cat.slug)}
              onKeyPress={(e: React.KeyboardEvent<HTMLAnchorElement>) =>
                handleKeyPress(e, cat.slug)
              }
            >
              {cat.name}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Wrapper>
  );
}

{
  /* <Link
                key={cat.id}
                href={`${getAppUrl(APP_URLS.blog, locale)}/category/${
                  cat.slug
                }`}
                passHref
              ></Link> */
}
